import { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Typography, useMediaQuery } from '@mui/material'
import dayjs from 'dayjs'

import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'
import { useNotificationsList } from 'services/notifications/notifications.hook'
import { NOTIFICATION_STATUS_TYPE } from 'services/notifications/notifications.consts'
import theme from 'styles/theme'
import NotificationsEmptyDetail from './NotificationsEmptyDetail'

const Notification: FC = () => {
  const { id } = useParams()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { getNotification, mutateAsyncNotificationUpdate } = useNotificationsList()

  const notification = getNotification(Number(id))
  const dateRaw = notification?.createDate || notification?.createdAt || notification?.created
  const dateLabel = dateRaw && dayjs(dateRaw).isValid() ? dayjs(dateRaw).format('DD.MM.YYYY') : undefined

  useEffect(() => {
    if (notification?.status === NOTIFICATION_STATUS_TYPE.unread) {
      mutateAsyncNotificationUpdate({
        ...notification,
        status: NOTIFICATION_STATUS_TYPE.read
      }).catch((err) => {
        console.error('Failed to update notification status:', err)
      })
    }
  }, [notification, mutateAsyncNotificationUpdate])

  if (!notification) {
    return isDesktop ? <NotificationsEmptyDetail /> : null
  }

  const body = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {isDesktop && (
        <Box>
          <Typography
            sx={{ fontSize: '20px', fontWeight: 700, lineHeight: '24px', color: theme.r4r.ink }}>
            {notification.title}
          </Typography>
          {!!dateLabel && (
            <Typography sx={{ fontSize: '12px', color: theme.r4r.grey, mt: '8px' }}>
              {dateLabel}
            </Typography>
          )}
        </Box>
      )}
      <Typography sx={{ fontSize: '14px', color: theme.r4r.ink, whiteSpace: 'pre-line' }}>
        {notification.text}
      </Typography>
    </Box>
  )

  if (isDesktop) {
    return (
      <Box sx={{ flex: 1, px: '48px', pt: '36px', pb: '48px' }}>
        {body}
      </Box>
    )
  }

  return (
    <>
      <BackNavigationHeader
        label={notification.title}
        navigateTo='/notifications'
      />
      <BackNavigationContent>{body}</BackNavigationContent>
    </>
  )
}

export default Notification
